(function($) {

    $(document).gp_ready(function () {
        $("form div.input-file").each(function () {
            const $wrapper = $(this)
            const $button  = $wrapper.find("button")
            const $input   = $wrapper.find("input[type=file]")
            const $label   = $wrapper.find("label")

            // show file picker on button click
            $button.on("click", function (e) {
                e.preventDefault()
                $input.trigger("click")
            })

            // update the file name label on file change
            $input.on("change", function () {
                const files = this.files
                const name = files && files.length
                    ? files[0].name
                    : this.placeholder

                $label.text(name)
            })
        })
    })

})(jQuery);
